// src/Pages/ArtistInstructions.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ.css";
import registerArtistImg from "../../assets/register-artist.png";
import createArtistImg from "../../assets/create-artist.png";

export default function ArtistInstructions() {
  return (
    <div className="faq-container">
      <h2 className="faq-heading">Artist Instructions</h2>
      <p className="faq-text">
        Creating an Artist profile on <strong>itiniri</strong> is simple and
        completely free!
      </p>
      <p className="faq-text">
        Create and manage your artist profile for an event:
      </p>
      <ol className="faq-steps">
        <li className="faq-step-item">Create an account at itiniri.app/auth</li>
        <li className="faq-step-item">
          Click <strong>Register a New Artist Profile</strong> section in your
          dashboard.
        </li>
        <img
          src={registerArtistImg}
          alt="Descriptive text"
          className="faq-image"
        />

        <li className="faq-step-item">
          If you have recieved a <strong>Gathering Reference ID</strong> from an
          Event, enter it here to link your profile to the Event.
        </li>
        <li className="faq-step-item">
          Enter your basic information and create your profile.
        </li>
        <li className="faq-step-item">
          In your Artist Dashboard, you can update your information, upload your
          profile image, and add several links to your social media or website.
        </li>
        <img
          src={createArtistImg}
          alt="Descriptive text"
          className="faq-image"
        />
        <li className="faq-step-item">
          If you have linked to an Event with a Gathering Reference ID, the
          Event schedule will appear. Click on the event you are a part of and
          click <strong>Claim</strong> to add your profile to that Event in the
          app.
        </li>
        <li className="faq-step-item">
          Make sure to click <strong>Save Changes</strong> to save your updates.
          All information made in your Artist Dashboard will be shown in the
          app.
        </li>
      </ol>
      <Link to="/faq" className="faq-back-link">
        ← Back to FAQ
      </Link>
    </div>
  );
}
